import React from 'react';

export default function ComissionsCircle() {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='24' height='24' rx='12' fill='#18181B' />
      <path
        d='M14.6663 18V16.6667C14.6663 15.9594 14.3854 15.2811 13.8853 14.781C13.3852 14.281 12.7069 14 11.9997 14H7.99967C7.29243 14 6.61415 14.281 6.11406 14.781C5.61396 15.2811 5.33301 15.9594 5.33301 16.6667V18M18.6663 18V16.6667C18.6659 16.0758 18.4692 15.5019 18.1073 15.0349C17.7453 14.5679 17.2384 14.2344 16.6663 14.0867M14.6663 6.08667C15.24 6.23354 15.7484 6.56714 16.1114 7.03488C16.4745 7.50262 16.6716 8.07789 16.6716 8.67C16.6716 9.26212 16.4745 9.83739 16.1114 10.3051C15.7484 10.7729 15.24 11.1065 14.6663 11.2533M12.6663 8.66667C12.6663 10.1394 11.4724 11.3333 9.99967 11.3333C8.52692 11.3333 7.33301 10.1394 7.33301 8.66667C7.33301 7.19391 8.52692 6 9.99967 6C11.4724 6 12.6663 7.19391 12.6663 8.66667Z'
        stroke='#A1A1AA'
        stroke-width='1.25'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
}
